import { BarcodeModel } from './barcode';
import { z } from 'zod';

export const BarcodeClassificationResult = z.object({
    type: z.string(),
    raw: BarcodeModel,
    properties: z.looseObject({
        additionalFlags: z.unknown().array().nullish(),
        assetMetadata: z
            .object({
                properties: z.record(z.string(), z.string()).nullish(),
            })
            .nullish(),
    }),
});

export type BarcodeClassificationResult = z.infer<typeof BarcodeClassificationResult>;
